/**
 * Debug handlers (d:*).
 */

import type { FlowStep } from "../types/flow";
import { resolveRecord, resolveValue } from "../expressions/resolve";
import { registerStepHandler } from "../runtime/step-registry";

function asRecord(step: FlowStep): Record<string, unknown> {
 return step as unknown as Record<string, unknown>;
}

registerStepHandler("d:log", (step, ctx) => {
 const r = asRecord(step);
 const msg = String(resolveValue(r["msg"], ctx) ?? "");
 const data = resolveRecord(r["data"] as Record<string, unknown>, ctx);
 const levelValue = resolveValue(r["level"], ctx);
 const levelNumber = typeof levelValue === "number" ? levelValue : Number(levelValue);
 const level = Number.isFinite(levelNumber) ? levelNumber :1;

 switch (level) {
 case 0:
 ctx.logger.debug(msg, data);
 break;
 case 2:
 ctx.logger.warn(msg, data);
 break;
 case 3:
 ctx.logger.error(msg, data);
 break;
 default:
 ctx.logger.info(msg, data);
 break;
 }
});